// extracted by mini-css-extract-plugin
export default {"wrapper":"ExamNumber_wrapper__FZcJA","select":"ExamNumber_select__sT0eh"};